import React, { useState } from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { Link } from 'gatsby';
import parseStoryblokLink from '../../utils/parse-storyblok-link';
import CtaWithArrow from '../cta-with-arrow';

const SystemCard = styled.div`
  width: 100%;
  border-top: 1px solid #ebebeb;
  padding: 20px 0;
  transition: 0.3s ease-in-out;

  &.active {
    border-top: 1px solid #161616;
    transition: 0.3s ease-in-out;
  }
`;

const TitleContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  cursor: pointer;
`;

const Title = styled.h3`
  color: #161616;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 100%;
  letter-spacing: -0.36px;
  transition: color 0.3s ease-in-out;
  &:hover {
    color: #3c3c3c;
    transition: 0.3s ease-in-out;
  }
  &.active {
    color: #161616;
    transition: color 0.3s ease-in-out;
  }
`;

const ExpandableContentOuterContainer = styled(motion.div)<{
  children: React.ReactNode;
}>`
  overflow: hidden;
`;

const ExpandableContentInnerContainer = styled(motion.div)<{
  children: React.ReactNode;
}>`
  display: flex;
  flex-direction: column;
  gap: 25px;
  padding-top: 20px;
  padding-bottom: 20px;
`;

const Description = styled.p`
  color: #666;
  font-size: 16px;
  font-weight: 400;
  line-height: 160%;
  letter-spacing: -0.16px;
  text-wrap: pretty;
`;

const outerContainerVariants = {
  hidden: { height: 0 },
  visible: { height: 'auto' }
};

const innerContainerVariants = {
  hidden: { opacity: 0 },
  visible: { opacity: 1 }
};

const transition = {
  ease: [0.87, 0, 0.13, 1],
  duration: 0.55,
  type: 'tween'
};

export default function SystemEntryExpandableCard({
  system,
  active,
  setActive
}: {
  system: any;
  active: boolean;
  setActive: () => void;
}) {
  const [isHovered, setIsHovered] = useState(false);
  return (
    <SystemCard className={active ? 'active' : ''} key={system.id}>
      <TitleContainer onClick={setActive}>
        <Title className={active ? 'active' : ''}>{system.systemTitle}</Title>
      </TitleContainer>
      <ExpandableContentOuterContainer
        initial={active ? 'visible' : 'hidden'}
        animate={active ? 'visible' : 'hidden'}
        variants={outerContainerVariants}
        transition={transition}
      >
        <ExpandableContentInnerContainer
          initial={active ? 'visible' : 'hidden'}
          animate={active ? 'visible' : 'hidden'}
          variants={innerContainerVariants}
          transition={transition}
          onHoverStart={() => setIsHovered(true)}
          onHoverEnd={() => setIsHovered(false)}
        >
          <Link
            to={parseStoryblokLink(system.systemCtaLink)}
            style={{ textDecoration: 'none' }}
          >
            <Description>{system.systemDescription}</Description>
          </Link>
          <CtaWithArrow
            link={parseStoryblokLink(system.systemCtaLink)}
            label={system.systemCtaLabel}
            isHovered={isHovered}
          />
        </ExpandableContentInnerContainer>
      </ExpandableContentOuterContainer>
    </SystemCard>
  );
}
